import React from 'react';
import { CheckCircle, Award, Users, Clock } from 'lucide-react';

const WhyChooseUs = () => {
  const benefits = [
    {
      icon: Award,
      title: 'Certified Experts',
      description: 'Our team holds industry-leading certifications in networking, security, and cloud technologies.',
      color: 'text-blue-500',
      bgColor: 'bg-blue-50',
    },
    {
      icon: Clock,
      title: '24/7 Support',
      description: 'Round-the-clock monitoring and support to ensure your systems are always running smoothly.',
      color: 'text-green-500',
      bgColor: 'bg-green-50',
    },
    {
      icon: Users,
      title: 'Proven Track Record',
      description: 'Years of experience delivering successful projects for businesses of all sizes.',
      color: 'text-purple-500',
      bgColor: 'bg-purple-50',
    },
    {
      icon: CheckCircle,
      title: 'Quality Guarantee',
      description: 'We stand behind our work with comprehensive warranties and satisfaction guarantees.',
      color: 'text-orange-500',
      bgColor: 'bg-orange-50',
    },
  ];

  return (
    <section className="section-padding bg-secondary-50">
      <div className="max-w-7xl mx-auto container-padding">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-text-primary mb-6">
            Why Choose <span className="text-gradient">Packet Path</span>
          </h2>
          <p className="text-xl text-text-secondary max-w-3xl mx-auto">
            Partner with us for reliable, professional IT services that drive your business forward
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {benefits.map((benefit, index) => {
            const IconComponent = benefit.icon;
            return (
              <div 
                key={benefit.title}
                className="card-hover group text-center animate-slide-up"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="p-8">
                  <div className={`w-16 h-16 ${benefit.bgColor} rounded-xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300`}>
                    <IconComponent className={`w-8 h-8 ${benefit.color}`} />
                  </div>
                  <h3 className="text-xl font-bold text-text-primary mb-4">
                    {benefit.title}
                  </h3>
                  <p className="text-text-secondary leading-relaxed">
                    {benefit.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA Section */}
        <div className="bg-gradient-tech rounded-2xl p-12 text-white text-center">
          <h3 className="text-2xl md:text-3xl font-bold mb-6">
            Ready to Upgrade Your IT Infrastructure?
          </h3>
          <p className="text-lg text-blue-100 mb-8 max-w-2xl mx-auto">
            Let's discuss your requirements and create a customized solution for your business.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="/contact" className="btn-secondary bg-white text-primary hover:bg-blue-50">
              Get Free Consultation
            </a>
            <a href="tel:+15551234567" className="btn-ghost text-white border-white hover:bg-white/10">
              Call Us Now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
